const withPostfix = (text: string, postfix: string): string => {
  if (!text.endsWith(postfix)) {
    return text + postfix
  }
  return text
}

export { withPostfix }
